import { Frame } from 'data/Frame';
import Layer from 'data/Layer';
import {
  ADD_FRAME,
  closeModal,
  removeFrame,
  removeLayer,
  selectFrame
} from 'state/actions';
import { getFrameById, getLayerById } from 'state/FlyerState';
import RootState from 'state/RootState';
import { newUUID, pause } from 'utils';
import { Command, CommandFunction } from './Command';

export class AddFrameCommand extends Command {
  layerId: string;
  frameId: string;
  constructor(layerId: string | undefined) {
    super();
    this.frameId = newUUID();
    this.layerId = layerId ?? newUUID();
    this.canMerge = false;
  }
  async dispatchWithFrame(
    dispatch: Function,
    frame: Frame,
    layer: Layer | undefined,
    closeModals: boolean,
    firstTime?: boolean
  ) {
    frame.id = this.frameId;
    if (firstTime && closeModals) {
      dispatch(closeModal());
      await pause(1);
    }
    dispatch({
      type: ADD_FRAME,
      frame,
      layer,
      layerId: this.layerId
    });
    if (firstTime) {
      await pause(1);
      dispatch(selectFrame(frame));
    }
  }
  undo(): CommandFunction {
    return async (dispatch: Function, getState: () => RootState) => {
      const { flyer } = getState();
      const layer = getLayerById(flyer, this.layerId);
      if (layer && layer.frames.length === 1) {
        dispatch(removeLayer(layer));
      } else {
        const frame = getFrameById(flyer, this.frameId);
        if (frame) {
          dispatch(removeFrame(frame));
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/AddFrameCommand.ts